import { Button, Modal, notification } from 'antd'
import axios from 'axios'
import React, { useState } from 'react'
import { Row } from 'react-display-flex'

import { messages } from '../messages'
import { MarketIndexTableItem } from '../models'

interface Props {
  marketIndex: MarketIndexTableItem
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const MarketIndexModalDelete = ({ marketIndex, isVisible, onClose, onSuccess }: Props) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const onDelete = async (marketIndexId: number) => {
    setIsDeleting(true)

    try {
      await axios.delete(`/market-indexes/${marketIndexId}`)
      notification.success({ message: messages.common.success, description: messages.marketIndex.delete.success })
      onSuccess()
    } catch (error) {
      notification.error({
        message: messages.common.error,
        description: error.error_message || messages.marketIndex.delete.error,
      })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      title="Delete Market Index"
      onCancel={onClose}
      open={isVisible}
      className="delete-modal-message"
      footer={
        <Row className="footer" justifyContentEnd>
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => onDelete(marketIndex.id)}
            disabled={isDeleting}
            loading={isDeleting}
            type="primary"
            danger
            aria-label="deleteMarketIndex"
          >
            Delete Market Index
          </Button>
        </Row>
      }
    >
      <p>Are you sure that you want to delete this market index?</p>
    </Modal>
  )
}
